var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgHouse20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.334 8.333h13.333v8.333c0 .917-.75 1.667-1.666 1.667H5c-.917 0-1.667-.75-1.667-1.667V8.333Z",
  fill: "#FFB1A5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.167 14.167h1.667c.458 0 .833.375.833.833v3.334H8.334V15c0-.458.375-.833.833-.833Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.234 2.5h1.525c.5 0 .908.408.908.908V8.4h-3.333V3.408c0-.5.408-.908.908-.908h-.008Z",
  fill: "#AE2F20"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.514 10.834H2.484c-.734 0-1.093-.907-.57-1.422l7.514-7.508a.807.807 0 0 1 1.142 0l7.515 7.5c.523.523.164 1.421-.57 1.421v.009Z",
  fill: "#F74F2A"
})));
export default SvgImgHouse20X20;